<template>
  <div class="sidebar-navigation" ref="sidebarWrapper" :style="sidebarStyles" v-bar="{preventParentScroll: true, scrollThrottle: 15, scrollingPhantomDelay: 200}">
    <div class="sidebar-inner" ref="sidebarInner" :style="innerSidebarStyles">
      <transition-group name="fade" tag="div">
        <base-inline-loader height="120" v-if="$props.loading" :key="'loader'"/>
        <template v-else>
          <template v-for="(topLevelService, topLevelIndex) in $props.menuItems">
            <div class="service-item" v-for="(singleService, index) in topLevelService.services" :key="'service'+topLevelIndex+index">
              <h4 class="acc-name" v-if="index === 0">
                {{ `${topLevelService.firstName} ${topLevelService.lastName ? topLevelService.lastName : ''}` }}
                <span v-if="singleService.type === 'BOX'">{{ singleService.title }}</span>
              </h4>
              <template v-if="singleService.packageServices && singleService.packageServices.length">
                <ul class="items-menu" role="menu" v-for="(packageService, packageIndex) in singleService.packageServices" :key="'package'+index+packageIndex">
                  <li role="menuitem">
                    <a href="#"
                       class="menu-item"
                       @click.prevent="selectItem(packageService.subscriberIdentity, packageService.type, '')"
                       :ref="packageService.subscriberIdentity"
                       :class="{'active': packageService.subscriberIdentity === selectedItem}">
                      <i class="icon" :class="getIcon(packageService.type)" :data-type="packageService.type"></i>
                      <div class="menu-item-inner">
                        <span class="item-name">{{ packageService.title }}</span>
                        <span class="item-sub">{{ packageService.description }}</span>
                      </div>
                    </a>
                    <transition name="expand" mode="out-in">
                      <ul class="items-submenu"
                          role="menu"
                          :style="submenuHeightStyle(getSubNavItemsForBox(packageService.type, singleService.type).length)"
                          v-if="subNavItems[packageService.type].length && packageService.subscriberIdentity === selectedItem">
                        <li v-for="(subService, idx) in getSubNavItemsForBox(packageService.type, singleService.type)"
                            :key="'sub'+idx+packageService.subscriberIdentity+index">
                          <a href="#"
                             class="submenu-item"
                             :class="{'active' : subService.type === selectedSubType}"
                             @click.prevent="selectItem(packageService.subscriberIdentity, packageService.type, subService.type)">
                            {{ subService.name }}
                          </a>
                        </li>
                      </ul>
                    </transition>
                  </li>
                </ul>
              </template>
              <template v-else>
                <ul class="items-menu" role="menu">
                  <li role="menuitem">
                    <a href="#"
                       class="menu-item"
                       @click.prevent="selectItem(singleService.subscriberIdentity, singleService.type, '')"
                       :ref="singleService.subscriberIdentity"
                       :class="{'active': singleService.subscriberIdentity === selectedItem}">
                      <i class="icon" :class="getIcon(singleService.type)" :data-type="singleService.type"></i>
                      <div class="menu-item-inner">
                        <span class="item-name">{{ singleService.title }}</span>
                        <span class="item-sub">{{ singleService.description }}</span>
                      </div>
                    </a>
                    <transition name="expand" mode="out-in">
                      <ul class="items-submenu"
                          role="menu"
                          :style="submenuHeightStyle(subNavItems[singleService.type].length)"
                          v-if="subNavItems[singleService.type].length && singleService.subscriberIdentity === selectedItem">
                        <li v-for="(subService, idx) in subNavItems[singleService.type]"
                            :key="'sub'+idx+singleService.subscriberIdentity+index">
                          <a href="#"
                             class="submenu-item"
                             :class="{'active' : subService.type === selectedSubType}"
                             @click.prevent="selectItem(singleService.subscriberIdentity, singleService.type, subService.type)">
                            {{ subService.name }}
                          </a>
                        </li>
                      </ul>
                    </transition>
                  </li>
                </ul>
              </template>
            </div>
          </template>
        </template>
      </transition-group>
    </div>
  </div>
</template>

<script>
import sidebarDebounce from '@/utils/debounce'

export default {
  name: 'services-sidebar',
  data () {
    return {
      selectedItem: '',
      selectedType: '',
      selectedSubType: '',
      navigationDisabled: false,
      navDisableTimeout: null,
      subNavItems: {
        TELEVISION: [
          {
            type: 'addons',
            name: this.$t('sidebarNavigation.sidebarSubNavigationItems.addons')
          }
        ],
        INTERNET: [],
        BOX: [],
        FIXED_TELEPHONY: [],
        MOBILE_PREPAID: [
          {
            type: 'addons',
            name: this.$t('sidebarNavigation.sidebarSubNavigationItems.addons')
          },
          {
            type: 'listing',
            name: this.$t('sidebarNavigation.sidebarSubNavigationItems.listing')
          },
          {
            type: 'topUp',
            name: this.$t('sidebarNavigation.sidebarSubNavigationItems.onlineTopUp')
          },
          {
            type: 'roaming',
            name: this.$t('sidebarNavigation.sidebarSubNavigationItems.roaming')
          }
        ],
        MOBILE_POSTPAID: [
          {
            type: 'addons',
            name: this.$t('sidebarNavigation.sidebarSubNavigationItems.addons')
          },
          {
            type: 'tariffChange',
            name: this.$t('sidebarNavigation.sidebarSubNavigationItems.changeTariff')
          },
          {
            type: 'listing',
            name: this.$t('sidebarNavigation.sidebarSubNavigationItems.listing')
          },
          {
            type: 'topUp',
            name: this.$t('sidebarNavigation.sidebarSubNavigationItems.onlineTopUp')
          },
          {
            type: 'roaming',
            name: this.$t('sidebarNavigation.sidebarSubNavigationItems.roaming')
          },
          {
            type: 'limitChange',
            name: this.$t('sidebarNavigation.sidebarSubNavigationItems.limitChange')
          }
        ]
      },
      sidebarHeight: 0,
      sidebarDebounceFn: () => sidebarDebounce(this.setSidebarHeight, 100),
      preventSubmenuEmit: false
    }
  },
  props: {
    menuItems: {
      type: Array,
      default: () => {
        return []
      }
    },
    subpageActive: Boolean,
    loading: Boolean,
    selectionBlocked: Boolean,
    hasNotification: Boolean
  },
  computed: {
    sidebarStyles () {
      if (typeof this.sidebarHeight === 'string') {
        return {
          height: this.sidebarHeight,
          maxHeight: 'calc(100% - 100px)'
        }
      }
      return {
        height: this.sidebarHeight + 'px'
      }
    },
    innerSidebarStyles () {
      if (typeof this.sidebarHeight === 'string') {
        return {
          height: '100%'
        }
      }
      return {
        height: this.sidebarHeight - 32 + 'px'
      }
    }
  },
  methods: {
    selectItem (id, type, subType) {
      // block selecting if navigation is not complete
      if (this.$props.selectionBlocked || this.navigationDisabled) return

      this.selectedItem = id
      this.selectedType = type
      this.selectedSubType = subType

      const submenuCount = this.subNavItems[type].length || 0
      setTimeout(() => {
        this.setSidebarHeight(submenuCount)
      }, 610)

      if (this.$props.subpageActive) {
        this.$emit('clear-subpage', { id: id, type: type, subType: subType })
      }
    },
    getIcon (serviceType) {
      switch (serviceType) {
        case 'TELEVISION':
          return 'icon-sc-tv'
        case 'INTERNET':
          return 'icon-sc-internet'
        case 'FIXED_TELEPHONY':
          return 'icon-sc-landline'
        case 'MOBILE_PREPAID':
          return 'icon-sc-mobile'
        default:
          return 'icon-sc-mobile'
      }
    },
    submenuHeightStyle (itemsCount) {
      return {
        height: `${itemsCount * 37}px`,
        transition: 'height 0.3s'
      }
    },
    getFirstItem (array) {
      if (!array.length) return {}
      for (let idx = 0; idx < array.length; idx++) {
        if (array[idx].services.length) {
          if (array[idx].services[0].packageServices && array[idx].services[0].packageServices.length) {
            return array[idx].services[0].packageServices[0]
          } else {
            return array[idx].services[0]
          }
        }
      }
    },
    setSidebarHeight (submenuCount = 0) {
      if (window.innerWidth >= 1024) {
        const sidebarMenuItems = this.$refs.sidebarInner ? this.$refs.sidebarInner.querySelectorAll('.service-item') : []
        let height = 0
        const submenuHeightBuffer = submenuCount > 1 ? 18 : 24

        sidebarMenuItems.forEach(item => {
          height += item.getBoundingClientRect().height + submenuHeightBuffer // each item has margin-bottom of 16px and icon has margin-top of 5px, that is not counted in height
        })

        const windowHeight = this.$props.hasNotification ? window.innerHeight - 140 : window.innerHeight - 112
        const maxHeight = Math.min(620, windowHeight)

        this.sidebarHeight = Math.min(height + 8, maxHeight)
      } else if (window.innerWidth < 1024 && window.innerWidth > 768) {
        this.sidebarHeight = 'auto'
      } else {
        const heightOffset = this.$props.hasNotification ? 134 : 94 // notification is 40px in height
        this.sidebarHeight = window.innerHeight - heightOffset
      }
    },
    preventDoubleEmitFromSubmenu () {
      this.preventSubmenuEmit = true
      const tempTimeout = setTimeout(() => {
        this.preventSubmenuEmit = false
        clearTimeout(tempTimeout)
      }, 300)
    },
    emitSidebarSelection (fromMain = false) {
      if (fromMain) this.preventDoubleEmitFromSubmenu()
      this.$emit('selected', { id: this.selectedItem, type: this.selectedType, subType: this.selectedSubType })
    },
    /**
     * A function that returns menu list for a specified service type
     * for this combination, client asked not to show 'Promjena tarife' item
     * for now, this is the easiest solution, if more changes to menu are needed, think about refactoring it
     * @param serviceType { String } Selected service (MOBILE_POSTPAID, TV, INTERNET...)
     * @param parentService { String } Parent service (BOX, MOBILE_POSTPAID...)
     * @returns {Array} returns complete selection from subNavItems object or filtered out tariffChange item
     */
    getSubNavItemsForBox (serviceType, parentService) {
      if (serviceType === 'MOBILE_POSTPAID' && parentService === 'BOX') {
        return this.subNavItems[serviceType].filter(item => item.type !== 'tariffChange')
      }

      return this.subNavItems[serviceType]
    }
  },
  watch: {
    selectedItem (newVal) {
      if (newVal) {
        this.emitSidebarSelection(true)
      }
    },
    selectedSubType (newVal) {
      if (newVal) {
        this.emitSidebarSelection()
      } else if (newVal === '') {
        if (!this.preventSubmenuEmit) this.emitSidebarSelection()
      }
    },
    '$props.menuItems': {
      handler (newVal) {
        if (newVal.length) {
          const { subscriberIdentity, type } = this.getFirstItem(newVal)
          this.selectedItem = subscriberIdentity
          this.selectedType = type
          this.selectedSubType = ''

          setTimeout(() => {
            this.setSidebarHeight()
          }, 610)
        }
      },
      immediate: true
    },
    '$props.loading': {
      handler (newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.setSidebarHeight()
          }, 610)
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        setTimeout(() => {
          this.setSidebarHeight()
        }, 610)
      })
    })
  },
  created () {
    window.addEventListener('orientationchange', () => {
      setTimeout(() => {
        this.setSidebarHeight()
      }, 800)
    })
  },
  beforeDestroy () {
    this.$off('navigation-complete')
  }
}
</script>
<style scoped lang="scss" src="./styles/sidebar.scss"></style>
